const onResizeCallbacks = [];

const horizontalTablet = Symbol('horizontalTablet');
const desktop = Symbol('desktop');

let currentAdaptive = desktop; // т.к. верстка изначально под десктоп

$('.persona').each(function eachSection(BlockIndex, Block) {
    const $block = $(Block);

    const $workLinks = $block.find('.persona__work-links');
    const $title = $block.find('.persona__subtitle');
    const $desctiption = $block.find('.persona__desctiption');

    const $aside = $block.find('.persona__aside');
    const $content = $block.find('.persona__content');

    onResizeCallbacks.push(onResize);

    function onResize() {

        if (horizontalTablet === currentAdaptive) {
            $workLinks.detach();

            $.each([$title, $desctiption, $workLinks], (index, element) => {
                $($aside).append(element);
            });
        }

        else if (desktop === currentAdaptive) {
            $.each([$desctiption, $title], (index, element) => {
                $content.prepend(element);
            });
        }
    }

    onResize();
});

$(window).on('resize', onResize);

onResize();

function onResize() {
    let adaptive;

    if (innerWidth < NLMK.mediaQueries.mobile.max) {
        adaptive = horizontalTablet;
    } else {
        adaptive = desktop;
    }

    if (currentAdaptive !== adaptive) {
        currentAdaptive = adaptive;

        onResizeCallbacks.forEach(callback => callback());
    }
}



// WEBPACK FOOTER //
// ./js/main/module/persona.js